/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {TokenModel} from "../../models/token-model";
import {RefreshModel} from "../../models/refresh-model";

export interface RefreshParams {
    body?: RefreshModel
}

export function identityRefreshPost(http: HttpClient, rootUrl: string, params: RefreshParams, context?: HttpContext): Observable<StrictHttpResponse<TokenModel>> {
    const rb = new RequestBuilder(rootUrl, identityRefreshPost.PATH, 'post');
    if (params) {
        rb.body(params.body, 'application/json');
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<TokenModel>;
        })
    );
}

identityRefreshPost.PATH = '/api/v1/identity/refresh';
